import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import CurrencyFormat from '@/utils/CurrencyFormat.ts';
import ScoreInadimplenciaMenu from '@/features/dashboard/ScoreInadimplenciaMenu';
import { VerticalAlignBottomTwoTone } from '@mui/icons-material';
import PeriodFilterYearMonthy from '@/components/Base/PeriodFilterYearMonthy';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { useNavigate } from 'react-router-dom';
import ScoreInadimplenciaCategoriaMenu from '@/features/dashboard/ScoreInadimplenciaCategoriaMenu';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import HeatMap from '@/features/heat-map/HeatMap..tsx';
import { useInadimplenciaHistoricalOverview } from '@/features/inadimplencia/api/getInadimplenciaHistoricalOverview.ts';
import { TitlePages } from '@/components/Base/TitlePage';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import { useInadimplenciaKpis } from '@/features/inadimplencia/api/getInadimplenciaHistorical';
import PeriodFilterYear from '@/components/Base/PeriodFilterYear';
import { generateLastYears } from '@/features/dashboard/CashFlowTela';

export const InadimplenciaPage = () => {
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));
  const [selectedYearHistorical, setSelectedYearHistorical] = useState(dayjs().year());
  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const {
    data: summary,
    isError,
    refetch,
    isFetching,
    isFetched,
  } = useInadimplenciaKpis({ year: selectedYear, month: selectedMonth });

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <TitlePages title={'Inadimplência'} />
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}


        {isFetching && <LoadingSummary />}

        {summary && isFetched && !isFetching && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponent
                title={'Valor total Inadimplente'}
                value={CurrencyFormat.format(summary?.total_inadimplencia)}
                tooltipText={'Valor acumulado de todos os boletos inadimplentes no ano atual.'}
                style={{minWidth: '160px'}}
                sign
              />
              <KpiComponent
                title={'Quantidades de contas inadimplência'}
                value={summary.qtd_contas_inadimplentes_ano_atual}
                tooltipText={'Quantidade de boletos em atraso no ano atual.'}
                style={{minWidth: '160px'}}
              />
              <KpiComponent title={'Percentual de inadimplência'}
                value={`${summary.percentual_de_inadimplencia}%`}
                tooltipText={'Relaciona Total a receber no ano e Total de boletos atrasados no ano corrente.'}
                style={{minWidth: '160px'}}
              />
            </Stack>
          </Stack>
        )}

        {isFetching && !summary && <LoadingSummary />}

        <Stack direction={'row'}>
          <Box marginTop={'10px'} width={'100%'}>
            <PeriodFilterDash
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              onStartDateChange={setSelectedStartDate}
              onEndDateChange={setSelectedEndDate}
              refetchDashboard={() => console.log('teste')}
              listYears={listYears}
              setSelectedYear={setSelectedYear}
              setSelectedMonth={setSelectedMonth}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              showPeriodFilter={false}
              showMonthFilter={false}
            />
          </Box>
        </Stack>

        <Grid mt={'10px'} container spacing={5}>
          <Grid item xs={12}>
            <ScoreInadimplenciaMenu
              year={parseInt(String(selectedYear)) || dayjs().year()}
              month={selectedMonth}
              setListYears={setListYears}
            />
        </Grid>

        <Grid item xs={12}>
          <ScoreInadimplenciaCategoriaMenu
            year={parseInt(String(selectedYear))}
            month={selectedMonth}
            days={dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" margin={'30px 0'} color={'#000'}>
            Inadimplência por cidade
          </Typography>
          <HeatMap year={selectedYear} />
        </Grid>
        </Grid>
      </Box>
    </>
  );
};
